import React from 'react'
import Router from './ReactRouter/Router'

const index = () => {
  return (<>
    <Router/>
  </>
  )
}

export default index